"use strict";
exports.__esModule = true;
exports.useAutocompleteStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.useAutocompleteStyles = styles_1.makeStyles(function (theme) {
    var _a;
    return styles_1.createStyles({
        clearIconOverwrite: {
            '& .MuiAutocomplete-clearIndicator': {
                color: (_a = theme.palette) === null || _a === void 0 ? void 0 : _a.secondary.main
            }
        }
    });
});
//# sourceMappingURL=styles.js.map